import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/home/Home';
import Classes from './pages/classes/Classes';
import Teachers from './pages/teachers/Teachers';
import Passes from './pages/passes/Passes';
import About from './pages/about/About';
import Book from './pages/book/Book';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/classes" element={<Classes />} />
          <Route path="/teachers" element={<Teachers />} />
          <Route path="/passes" element={<Passes />} />
          <Route path="/about" element={<About />} />
          <Route path="/book" element={<Book />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
